<script>
    import { query, search_terms } from "../stores";
</script>

<ul class="text-search">
    {#each $search_terms as term, i}
        <li><a on:click|preventDefault={ () => query.remove(term) } href="#n">{term.toString()}</a></li>
    {/each}
</ul>

<style>
    li {
        display: inline;
        margin-right: 10px;
    }
</style>
